import { render, staticRenderFns } from "./RegVSAtt.vue?vue&type=template&id=7c23856e&"
import script from "./RegVSAtt.vue?vue&type=script&lang=js&"
export * from "./RegVSAtt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports